const {h, render, Component} = require('preact');

class EmailInput extends Component {
  constructor(props) {
      super(props);
  }

  render() {
    var invalid = !(this.props.isValid == true)
    return (
      <div>
        { (!this.props.isValid && <div class="icon-circle-alert">{I18n.t('js.modules.web_2018.enter_valid_email_id')}</div>) }
        <input value={this.props.emailId} oninput={(e) => this.props.handleInputChange('emailId', e)} type="text" class="email-id-input" id="email-id-input" data-bhw="guest_checkout_email_field" placeholder={I18n.t('js.modules.web_2018.email_id_placeholder')} invalid={invalid}></input>
      </div>
    )
  }
}

module.exports = EmailInput
